import { type FC, useEffect, useState } from 'react';

import Card from 'react-bootstrap/Card';
import './styles/styles.css';

import { capitalCase } from 'case-anything';
import { DateTime } from 'luxon';
import { Badge, Col, Row } from 'react-bootstrap';
import { BoxArrowInLeft, BoxArrowInRight, People } from 'react-bootstrap-icons';
import { type MewsReservation, PackagesResponse } from '../../../modules/interfaces';

import { statusTextColorMapper } from '../../../modules/mappers/statusColorMapper';

interface PackageCardProps {
  reservation?: MewsReservation;
}

const formatManageCardDate = (isoDate: string) => {
  const tz = process.env.REACT_APP_LODGING_LOCATION_TIMEZONE;
  const dateTime = DateTime.fromISO(isoDate, { zone: tz });

  const formatDate = dateTime.isValid
    ? dateTime.toFormat('MMM d, yyyy, h:mm a')
    : 'Not provided';

  return formatDate;
};

export const GuestPortalManagerCard: FC<PackageCardProps> = ({ reservation }) => {
  const roomImage = reservation?.Room?.media?.[0]?.uri ?? '/no_image.jpg';
  return (
    <Card className="gb-manage-card">
      <Row>
        <Col style={{ display: 'flex', justifyContent: 'end' }}>
          <div title="" className="page-dropdown package-actions manage-status-badge">
            <Badge
              className="status-badge"
              bg={statusTextColorMapper[reservation?.State || 'Not provided']}
            >
              {capitalCase(reservation?.State || 'Not provided')}
            </Badge>
          </div>
        </Col>
      </Row>

      <Card.Img
        variant="top"
        src={roomImage}
        className="d-inline-block align-top gb-manage-card-image"
      />
      <Card.Body style={{ marginTop: '8px', padding: '0px 5px' }}>
        <Row>
          <Col sm={8}>
            <span className="gb-manager-title">
              {reservation?.Resource?.ResourceName}{' '}
            </span>
          </Col>
          <Col sm={4}>
            <span className="gb-manager-title">
              {`$${reservation?.Prices?.total} USD`}{' '}
            </span>
          </Col>
        </Row>
        <Row style={{ marginTop: '10px' }}>
          <Col sm={8}>
            <div>
              <span className="gb-manager-subtitle">
                <BoxArrowInRight size={15} />{' '}
                {formatManageCardDate(reservation?.StartUtc || '')}
                <br />
                <BoxArrowInLeft size={15} />{' '}
                {formatManageCardDate(reservation?.EndUtc || '')}
              </span>
            </div>
          </Col>
          <Col sm={4} style={{ display: 'flex', alignItems: 'center' }}>
            <Badge bg="secondary">
              <div>
                <People size={15} /> {`${reservation?.PersonCounts[0].Count} guests`}
              </div>
            </Badge>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
